import { Validator } from 'vee-validate'

import postalCode from '@/validation/rules/postalCode.js'

export default {
  // This is where you define your own custom rules
  rules: {
    postalCode,
    postalCodeDK: {
      validate: value => {
        const reg = new RegExp(/^\d{4}$/)
        return reg.test(value)
      }
    },
    mobile: {
      validate: value => {
        const reg = new RegExp(/^\+\d{8,15}$/)
        return reg.test(value)
      }
    }
  },
  // This function registers the custom rules to the validator
  register() {
    Object.entries(this.rules).forEach(([key, value]) =>
      Validator.extend(key, value)
    )
  }
}
